export default __webpack_public_path__ + "static/media/Chart Screenshot.dfef5c01.png";